// src/pushNotification.js
import {messaging, getToken, onMessage, initializeFirebaseMessaging} from './firebase';
import { fetchRegisterDeviceToken } from './api/api.app';

export const initializePushNotifications = (webParams) => {
    console.log('Initializing push notifications');

    if (!('Notification' in window)) {
        console.warn('This browser does not support notifications.');
        return;
    }


    // Exécution après que la page soit chargée
    /*window.addEventListener('load', async () => {
        alert('Page loaded, initializing Service Worker');
        console.log('Page loaded, initializing Service Worker');
        if ('serviceWorker' in navigator) {
            try {
                console.log('Service Worker is supported');
                // 1. Appel du webservice
                const response = await fetch('/api/get-sw-config');
                const data = await response.json();

                // 2. Choisir le SW à charger selon la réponse*/
                let swPath = '/firebase-messaging-sw-'+webParams.firebase_project_id+'.js';

                console.log('Service Worker path:', swPath);
                console.log(webParams)
                //}

                // 3. Enregistrement du Service Worker
                const registration = navigator.serviceWorker.register(swPath);
                console.log('Service Worker enregistré avec succès:', registration);/*
            } catch (error) {
                console.error('Erreur lors de l’enregistrement du Service Worker:', error);
            }
        }
    });*/


    const messaging = initializeFirebaseMessaging(webParams);

    Notification.requestPermission().then((permission) => {
        if (permission === 'granted') {
            getToken(messaging, {
                vapidKey: webParams.firebase_v_api_key,
            })
                .then((currentToken) => {
                    if (currentToken) {
                        console.log('Token:', currentToken);
                        fetchRegisterDeviceToken(currentToken);
                    } else {
                        console.log('No registration token available.');
                    }
                })
                .catch((err) => {
                    console.error('Error getting token:', err);
                });
        } else {
            console.log('Notification permission not granted');
        }
    });

    onMessage(messaging, (payload) => {
        console.log('Foreground message received:', payload);

        if (Notification.permission === 'granted') {
            const { title, body, icon } = payload.notification;

            new Notification(title, {
                body,
                icon: icon || '/firebase-logo.png',
            });
        }
    });
};